module.exports = __webpack_public_path__ + "media/img/pages/companies/sicpa-a0b655d0de41de27c9a691bafb619a05.png";